module.exports = __webpack_public_path__ + "static/img/training_widget_1.79969b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/training_widget_1.png
// module id = rpmM
// module chunks = 11